var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 204,
    height: 225,
    viewBox: "0 0 204 225",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4251_14743)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.074 12.7773C105.574 46.7941 97.862 74.7791 85.3116 107.384C79.9735 121.253 72.2373 134.12 64.5639 146.847C60.7222 153.218 55.9338 159.02 50.8833 164.483C45.4206 170.392 35.8178 174.787 28.1151 173.362C0.932427 168.334 11.467 124.019 37.828 126.657C49.1968 127.793 59.0673 132.109 65.8613 135.254C71.9938 138.092 104.422 151.977 125.211 181.862",
    stroke: "white",
    strokeWidth: 3.81955,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.664 175.222L127.067 184.602L118.184 181.675",
    stroke: "white",
    strokeWidth: 3.81955,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4251_14743"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 127,
    height: 186.203,
    fill: "white",
    transform: "matrix(0.866025 0.5 0.5 -0.866025 0 161.257)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArr);
export default __webpack_public_path__ + "static/media/arr.3418a98ca8d1c60e8ee9aa5f5556e19d.svg";
export { ForwardRef as ReactComponent };